import { render, staticRenderFns } from "./RolesPopup.vue?vue&type=template&id=36492b0d"
import script from "./RolesPopup.vue?vue&type=script&lang=js"
export * from "./RolesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports